import React from 'react';
import { useTranslation } from 'react-i18next';
import { Loader } from '../Loader/Loader';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Base button atom behavior.
 *
 * Will be extended by a styled component for styling. See Primary.styled.tsx, etc.
 *
 * Preferred way to use button atoms:
 * ```
 * import { Button, Link } from '../../atoms/Button'
 * <Button.PrimaryBrand>Button</Button>
 * <Link.PrimaryBrand>Link</Link>
 * ```
 */
export function Button({
  type,
  isLoading,
  disabled,
  children,
  ...rest
}) {
  const {
    t
  } = useTranslation('blocks.buttons');
  return /*#__PURE__*/_jsx("button", {
    // "type" and ternary statement necessary to satisfy ESLint
    type: type === 'submit' ? 'submit' : 'button',
    disabled: isLoading || disabled,
    ...rest,
    children: isLoading ? /*#__PURE__*/_jsx(Loader, {
      "aria-label": t('Button.loader.ariaLabel', 'Loading'),
      circleDiameter: "6px",
      circleSpacing: "12px",
      children: children
    }) : children
  });
}